<tm-map-drawing-buttons [allowedShapes]="allowedGeometryTypes"
                        [drawingLayerId]="drawingLayerId"
                        [drawSingleShape]="true"
                        [allowRemoveSelectedFeature]="true"
                        [allowModify]="true"
                        [selectedFeature]="selectedFeatureForModifyTool$ | async"
                        [selectionStyle]="selectedStyle"
                        (drawingAdded)="drawingAdded($event)"
                        (featureSelected)="onFeatureSelected($event)"
                        (featureGeometryModified)="onFeatureGeometryModified($event)"
                        (featureRemoved)="featureRemoved($event)"></tm-map-drawing-buttons>
